import { useState } from 'react';
import { BaseEdge, EdgeLabelRenderer, getBezierPath, EdgeProps } from '@xyflow/react';
import { Trash2 } from 'lucide-react';
import type { FlowEdgeData } from '@/types/flow';

export default function CustomEdge({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    sourceHandleId,
    style = {},
    markerEnd,
    data,
    selected,
}: EdgeProps) {
    const [hovered, setHovered] = useState(false);

    const [edgePath, labelX, labelY] = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });

    const edgeData = data as FlowEdgeData | undefined;

    const onEdgeClick = (evt: React.MouseEvent) => {
        evt.stopPropagation();
        if (edgeData?.onDelete && edgeData?.id) {
            edgeData.onDelete(edgeData.id);
        }
    };

    const isButtonConnection = sourceHandleId?.startsWith('button-');
    const buttonLabel = edgeData?.buttonText || (isButtonConnection ? 'Botão' : null);
    const showDelete = hovered || selected;

    return (
        <>
            {/* Invisible wider path for easier hover detection */}
            <path
                d={edgePath}
                fill="none"
                stroke="transparent"
                strokeWidth={20}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                style={{ cursor: 'pointer' }}
            />
            {/* Visible edge - highlights on hover */}
            <BaseEdge
                path={edgePath}
                markerEnd={markerEnd}
                style={{
                    ...(style as React.CSSProperties),
                    stroke: showDelete ? '#1976D2' : '#2196F3',
                    strokeWidth: showDelete ? 2.5 : 2,
                    transition: 'stroke 0.15s, stroke-width 0.15s',
                }}
            />
            <EdgeLabelRenderer>
                <div
                    style={{
                        position: 'absolute',
                        transform: `translate(-50%, -100%) translate(${labelX}px,${labelY - 12}px)`,
                        fontSize: 12,
                        pointerEvents: 'all',
                        opacity: showDelete || buttonLabel ? 1 : 0,
                        transition: 'opacity 0.15s ease',
                    }}
                    className="nodrag nopan"
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                >
                    <div className="flex flex-col items-center gap-1.5">
                        {buttonLabel && (
                            <div className="bg-[#2196F3] text-white px-3 py-1 rounded-full text-[11px] font-medium shadow-sm whitespace-nowrap">
                                {buttonLabel}
                            </div>
                        )}

                        {showDelete && (
                            <button
                                onClick={onEdgeClick}
                                className="w-9 h-9 bg-white hover:bg-red-50 text-red-400 hover:text-red-600 rounded-xl flex items-center justify-center shadow-lg transition-all border border-gray-200 hover:border-red-300 animate-in fade-in zoom-in-50 duration-150"
                                title="Remover conexão"
                            >
                                <Trash2 className="w-4.5 h-4.5" />
                            </button>
                        )}
                    </div>
                </div>
            </EdgeLabelRenderer>
        </>
    );
}